import React from 'react';
import { Route } from 'react-router-dom';
import { Switch } from 'react-router';
// TODO: refactoring.
import asyncComponent from 'util/asyncComponent';
import { PASSWORD_RESET_PAGE } from 'new-design/routes/common/constants';

const Routes = () => {
  return (
    <Switch>
      <Route path={`/terms`} component={(asyncComponent(() => import('../../pages/public/Terms')))}/>
      <Route path={`/policy`} exact component={(asyncComponent(() => import('../../pages/public/Privacy')))}/>
      <Route path={PASSWORD_RESET_PAGE} exact component={(asyncComponent(() => import('../../pages/PasswordReset')))}/>
    </Switch>
  );
}

export default Routes;

